import { createSlice } from "@reduxjs/toolkit";
import {
  createNewsletterBuilder,
  getNewslettersBuilder,
  deleteNewsletterBuilder,
  sendEmailsBuilder,
} from "./builder";

const initialState = {
  loading: false,
  newsletters: {
    data: [],
    pagination: {},
    loading: false,
    deleteLoading: false,
    sendEmailsLoading: false,
    lastEmailResults: null,
    error: null,
  },
};

export const newsletterSlice = createSlice({
  name: "newslettersInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createNewsletterBuilder(builder);
    getNewslettersBuilder(builder);
    deleteNewsletterBuilder(builder);
    sendEmailsBuilder(builder);

    builder.addCase("logout", () => ({
      ...initialState,
      loggedIn: false,
      user: null,
    }));
  },
});

// export const {} = newsletterSlice.actions;

export const selectNewsletterLoading = (state) => state.newslettersInfo.loading;
export const selectNewsletters = (state) => state.newslettersInfo.newsletters;

export default newsletterSlice.reducer;
